import React from "react";
import tw from "twin.macro"; //eslint-disable-line
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Link } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import HeaderWithNavbar from "components/columns/NavbarBackgroundAsImage.js";
import Features from "components/features/DashedBorderSixFeatures";
import BizCodeHistory from "components/features/ProjectBizCodeHistory.js";
import OurProfessionalTeam from "components/features/OurProfessionalTeam.js";
import Portfolio from "components/cards/PortfolioTwoCardsWithImage.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import Footer from "components/footers/FourColumnWithInputForm.js";
import personIlustration from "images/professional-illustration.svg";
import girlIlustration from "images/girl-illustration.svg";
import DownloadApp from "components/cta/DownloadApp.js";
import ContactUsForm from "components/forms/ContactUsForm";
import TwoColumnWithImage from "components/columns/TwoColumnWithImage";
import TwoColumnWithImageLeft from "components/columns/TwoColumnWithImageLeft";
import QrDeviceSrc from "images/qrdevice.png";
import DoorSrc from "images/barrera.png";
import CamaraSrc from "images/camara.png";
import biometrics from "images/demo/biometrics.jpg"
import software from "images/demo/software.jpg"
import { SectionHeading } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { ContentWithPaddingXl } from "components/misc/Layouts.js";
import ShieldIconImage from "images/shield-icon.svg";
import SupportIconImage from "images/support-icon.svg";
import CustomizeIconImage from "images/customize-icon.svg";
import FastIconImage from "images/fast-icon.svg";
import ReliableIconImage from "images/reliable-icon.svg";
import SimpleIconImage from "images/simple-icon.svg";
import { ReactComponent as CodeIcon } from "feather-icons/dist/icons/code.svg";
import { ReactComponent as ServerIcon } from "feather-icons/dist/icons/server.svg";
import { ReactComponent as HomeIcon } from "feather-icons/dist/icons/home.svg";
import { ReactComponent as ShoppingCartIcon } from "feather-icons/dist/icons/shopping-cart.svg";
import { ReactComponent as ActivityIcon } from "feather-icons/dist/icons/activity.svg";
import { ReactComponent as SlidersIcon } from "feather-icons/dist/icons/sliders.svg";
import { ReactComponent as CheckCircleIcon } from "feather-icons/dist/icons/check-circle.svg";
import { ReactComponent as ArrowRightIcon } from "feather-icons/dist/icons/arrow-right.svg";
import GymSrc from "images/demo/gym-example.webp";
import CondoSrc from "images/demo/condominio-residencial.jpg";
import ecomerce from "images/demo/e-comerce.jpg"
import Iotexample from "images/demo/IoT-example.jpg"

const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;

const VenueSection = styled.div`${tw`py-16 bg-gray-300`}`;
const VenueGrid = styled.div`${tw`max-w-screen-xl mx-auto px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8`}`;
const VenueHeading = tw(SectionHeading)`text-center mb-4`;
const VenueSubtitle = tw(SectionDescription)`text-center mx-auto mb-12 max-w-2xl`;
const VenueCard = styled.div`${tw`bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center transition-all duration-300 hover:shadow-xl`}`;
const VenueEmoji = tw.div`text-5xl mb-4`;
const VenueTitle = tw.h3`text-xl font-bold text-primary-700 mb-2`;
const VenueDesc = tw.p`text-gray-600 text-sm leading-relaxed`;

const IoTSection = styled.div`${tw`py-16 bg-primary-300 text-white`}`;
const IoTInner = tw.div`max-w-screen-xl mx-auto px-8`;
const IoTHeading = tw.h2`text-3xl sm:text-4xl font-black text-center mb-4 text-white`;
const IoTSubtitle = tw.p`text-gray-300 text-center max-w-2xl mx-auto mb-12 text-lg`;
const IoTGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6`;
const IoTCard = styled.div`${tw`bg-primary-800 rounded-xl p-6 flex flex-col items-center text-center`}`;
const IoTCardIcon = tw.div`text-4xl mb-3`;
const IoTCardTitle = tw.h4`text-white font-bold text-lg mb-2`;
const IoTCardDesc = tw.p`text-gray-400 text-sm leading-relaxed`;

const SecuritySection = styled.div`${tw`py-16 bg-white`}`;
const SecurityInner = tw.div`max-w-screen-xl mx-auto px-8`;
const SecurityHeading = tw(SectionHeading)`text-center mb-4`;
const SecuritySubtitle = tw(SectionDescription)`text-center mx-auto mb-12 max-w-2xl`;
const LayersGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6`;
const LayerCard = styled.div`${tw`border-2 border-primary-200 rounded-xl p-6 text-center hover:border-primary-500 transition-all duration-300`}`;
const LayerNumber = tw.div`text-4xl font-black text-primary-500 mb-2`;
const LayerTitle = tw.h4`text-lg font-bold text-gray-800 mb-2`;
const LayerDesc = tw.p`text-gray-600 text-sm leading-relaxed`;

const WhatWeDoSection = styled.div`${tw`py-16 bg-gray-100`}`;
const WhatWeDoInner = tw.div`max-w-screen-xl mx-auto px-8`;
const WhatWeDoHeading = tw(SectionHeading)`text-center mb-4`;
const WhatWeDoSubtitle = tw(SectionDescription)`text-center mx-auto mb-12 max-w-3xl`;
const CapabilitiesGrid = tw.div`grid grid-cols-2 sm:grid-cols-4 gap-6`;
const CapabilityCard = styled.div`${tw`bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center`}`;
const CapabilityEmoji = tw.div`text-4xl mb-3`;
const CapabilityTitle = tw.h4`text-primary-700 font-bold text-sm sm:text-base`;

const ProductsSection = styled.div`${tw`py-16 bg-secondary-500 text-white`}`;
const ProductsInner = tw.div`max-w-screen-xl mx-auto px-8`;
const ProductsHeading = tw.h2`text-3xl sm:text-4xl font-black text-center mb-4 text-white`;
const ProductsSubtitle = tw.p`text-gray-300 text-center max-w-3xl mx-auto mb-12 text-lg`;
const ProductsGrid = tw.div`grid grid-cols-1 lg:grid-cols-2 gap-8`;
const ProductCard = styled.div`${tw`bg-white text-gray-900 rounded-2xl shadow-xl overflow-hidden flex flex-col`}`;
const ProductImage = styled.div`
  ${tw`h-48 bg-cover bg-center`}
  background-image: url(${props => props.imageSrc});
`;
const ProductBody = tw.div`p-8 flex flex-col flex-1`;
const ProductIconRow = tw.div`flex items-center mb-4`;
const ProductIconWrapper = styled.div`
  ${tw`p-3 rounded-full bg-primary-500 text-white mr-4 flex-shrink-0`}
  svg { ${tw`w-6 h-6`} }
`;
const ProductTitle = tw.h3`text-xl font-bold text-primary-700`;
const ProductDesc = tw.p`text-gray-600 text-sm leading-relaxed mb-4`;
const ProductFeatures = tw.ul`mb-6 flex-1`;
const ProductFeatureItem = styled.li`
  ${tw`flex items-start text-sm text-gray-700 mb-2`}
  svg { ${tw`w-4 h-4 text-primary-500 mr-2 mt-1 flex-shrink-0`} }
`;
const HardwareBadge = tw.span`inline-block text-xs font-bold uppercase tracking-wide text-primary-700 bg-gray-300 rounded-full px-3 py-1 mb-4 self-start`;
const ProductCTA = styled(Link)`
  ${tw`inline-flex items-center self-start font-bold text-primary-500 hocus:text-primary-700 transition duration-300`}
  svg { ${tw`w-4 h-4 ml-2`} }
`;

export default () => {
  const sendMessage = (formData) => {
    const { name, email, subject, message } = formData;
    const text = `Nombre: ${name}\nEmail: ${email}\nAsunto: ${subject}\nMensaje: ${message}`;
    const phone = "3325646932";
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  const serviceCards = [
    {
      imageSrc: ShieldIconImage,
      title: "Control de Acceso Avanzado",
      description: "QR dinámico anti-fraude, reconocimiento facial y tarjetas digitales. Funciona sin internet en el momento del acceso. Ideal para condominios, escuelas y gimnasios."
    },
    {
      imageSrc: CustomizeIconImage,
      title: "Desarrollo de Software a Medida",
      description: "Plataformas web y móviles completamente personalizadas para tu empresa. Del concepto al despliegue en producción con metodologías ágiles."
    },
    {
      imageSrc: FastIconImage,
      title: "Integración IoT",
      description: "Conectamos sensores, cámaras, barreras, torniquetes y dispositivos inteligentes en una sola plataforma centralizada en la nube."
    },
    {
      imageSrc: ReliableIconImage,
      title: "Videovigilancia con IA",
      description: "Análisis de video en tiempo real con OpenCV. Detección de patrones sospechosos, registro automático y alertas inteligentes."
    },
    {
      imageSrc: SupportIconImage,
      title: "Soporte y Mantenimiento",
      description: "Equipo técnico disponible para incidentes, actualizaciones y optimizaciones. Tu operación no se detiene."
    },
    {
      imageSrc: SimpleIconImage,
      title: "Cloud y On-Premises",
      description: "Desplegamos en Azure, AWS, GCP o en infraestructura local según tus requerimientos de seguridad, latencia y normativas."
    }
  ];

  const venues = [
    { emoji: "🏘️", title: "Fraccionamientos y Condominios", desc: "Control total de visitantes, residentes y proveedores. Invitaciones QR anti-fraude y administración completa desde un panel." },
    { emoji: "🏫", title: "Escuelas y Universidades", desc: "Acceso controlado por rol. Registro automático de entradas/salidas y alertas en tiempo real para padres y personal." },
    { emoji: "💪", title: "Gimnasios y Clubes", desc: "Torniquetes que verifican membresía activa automáticamente. Sin filas ni recepcionistas — acceso fluido las 24 horas." },
    { emoji: "🏨", title: "Airbnb y Hoteles Boutique", desc: "QR o PIN temporal para huéspedes. Gestión remota total desde el teléfono del propietario, sin presencia física." },
    { emoji: "🏢", title: "Oficinas y Corporativos", desc: "Control por áreas y roles. Visitantes registrados, bitácora digital y reportes de afluencia para auditorías." },
    { emoji: "🏭", title: "Plantas Industriales", desc: "Acceso diferenciado en zonas restringidas. Integración con ERP y registro fotográfico en puntos críticos." }
  ];

  const iotFeatures = [
    { icon: "📷", title: "Cámaras IP / RTSP", desc: "Compatible con HiLook, Hikvision, Dahua. Análisis de video con OpenCV en tiempo real directamente desde el stream." },
    { icon: "🚧", title: "Barreras y Torniquetes", desc: "Integración con ZKTeco, CAME, FAAC y relés vía ESP32. Apertura automática al validar QR o biometría." },
    { icon: "🔒", title: "Cerraduras Inteligentes", desc: "Cerraduras eléctricas, magnéticas o con motor. Apertura remota desde la app o automática al validar acceso." },
    { icon: "📟", title: "Sensores y Alarmas", desc: "Sensores de movimiento, temperatura y apertura de puertas. Alertas push al administrador en tiempo real." }
  ];

  const securityLayers = [
    { number: "01", title: "QR Dinámico TOTP", desc: "El código cambia cada 30 segundos con el algoritmo TOTP (RFC 6238). Una captura de pantalla compartida por WhatsApp caduca antes de llegar al destino." },
    { number: "02", title: "Filtros Ópticos", desc: "La cámara detecta si el QR viene de una pantalla real o de una foto comprimida mediante varianza Laplaciana y análisis de Fourier." },
    { number: "03", title: "Token de Un Solo Uso", desc: "Cada código se quema en la base de datos al primer escaneo exitoso. Presentar el mismo QR dos veces siempre resulta en acceso denegado." },
    { number: "04", title: "Interfaz Anti-Video", desc: "Fondo animado y reloj con milisegundos hacen que cualquier grabación sea detectada por los filtros ópticos." }
  ];

  const capabilities = [
    { emoji: "🏢", title: "Sistemas ERP a la medida" },
    { emoji: "🌐", title: "Sitios Web Informativos" },
    { emoji: "🛒", title: "Plataformas eCommerce" },
    { emoji: "🏠", title: "Domótica e IoT" }
  ];

  const products = [
    {
      imageSrc: CondoSrc,
      Icon: HomeIcon,
      title: "Conexa Home — Control de Accesos para Condominios",
      description: "Nuestro producto insignia, la aplicación que impulsa este mismo sitio. Gestiona visitantes, residentes, áreas comunes, pagos y comunicados desde un solo panel administrativo, con QR dinámico anti-fraude y validación sin internet en el punto de acceso.",
      features: [
        "Invitaciones QR con TOTP y token de un solo uso",
        "Administración de residentes, áreas comunes y pagos",
        "Venta, instalación y puesta en marcha del hardware (totems, barreras, cámaras)"
      ],
      hardware: true,
      ctaText: "Conocer la aplicación",
      ctaTo: "/"
    },
    {
      imageSrc: ecomerce,
      Icon: ShoppingCartIcon,
      title: "eCommerce y Punto de Venta",
      description: "Desarrollamos tiendas en línea y sistemas de punto de venta a la medida para negocios que buscan digitalizar sus ventas, con catálogos, inventario, pagos en línea y reportes en tiempo real.",
      features: [
        "Carrito de compras, pasarelas de pago y facturación",
        "Punto de venta (POS) para tienda física y en línea",
        "Panel de inventario, reportes de ventas y clientes"
      ],
      hardware: false
    },
    {
      imageSrc: GymSrc,
      Icon: ActivityIcon,
      title: "Control de Accesos y App Móvil para Gimnasios",
      description: "Torniquetes que validan membresías activas automáticamente y una app móvil personal para cada suscriptor, con seguimiento de rutinas diarias de ejercicio y plan alimenticio.",
      features: [
        "Validación automática de membresías en el acceso",
        "App móvil con rutinas de ejercicio y plan alimenticio personalizado",
        "Venta, instalación y puesta en marcha del hardware de acceso"
      ],
      hardware: true
    },
    {
      imageSrc: Iotexample,
      Icon: SlidersIcon,
      title: "Domótica para el Hogar",
      description: "Integramos cámaras de seguridad, sensores, alarmas, interruptores y luces inteligentes, además de riego automático para el jardín, todo administrado desde una sola app web.",
      features: [
        "Cámaras de seguridad, sensores y alarmas en una sola app",
        "Control de interruptores, luces y riego automático del jardín",
        "Venta e instalación de paneles empotrados en pared, cámaras y motores solenoides"
      ],
      hardware: true
    }
  ];

  return (
    <AnimationRevealPage>
      <HeaderWithNavbar />

      <BizCodeHistory
        subheading="Nuestra Historia"
        heading={<>Creando tecnología <wbr /> desde <span tw="text-primary-500">2020.</span></>}
        description="BizCode GDL es una empresa de desarrollo de software con sede en Guadalajara, México. Nos especializamos en sistemas de control de acceso, plataformas de gestión para fraccionamientos, sistemas de gestion para gimnasios, domotica, integración IoT y desarrollo de software a medida. Nuestro equipo combina experiencia en React JS, .NET Core, computer vision y hardware embebido para entregar soluciones completas — del código al torniquete."
        primaryButtonText="Nuestros Servicios"
        primaryButtonUrl="#feature"
        imageSrc={software}
        textOnLeft={true}
        statistics={[
          { key: "Clientes activos", value: "10+" },
          { key: "Proyectos entregados", value: "15+" },
          { key: "Años de experiencia", value: "5+" }
        ]}
      />

      <WhatWeDoSection>
        <WhatWeDoInner>
          <WhatWeDoHeading>Software a la Medida para Pequeñas y Medianas Empresas</WhatWeDoHeading>
          <WhatWeDoSubtitle>
            Somos una empresa de desarrollo de software especializada en crear soluciones a la medida.
            Diseñamos, construimos e implementamos sistemas ERP, sitios web informativos, plataformas eCommerce
            y soluciones de domótica e IoT, adaptadas a las necesidades reales de tu negocio.
          </WhatWeDoSubtitle>
          <CapabilitiesGrid>
            {capabilities.map((c, i) => (
              <CapabilityCard key={i}>
                <CapabilityEmoji>{c.emoji}</CapabilityEmoji>
                <CapabilityTitle>{c.title}</CapabilityTitle>
              </CapabilityCard>
            ))}
          </CapabilitiesGrid>
        </WhatWeDoInner>
      </WhatWeDoSection>

      <Features
        heading={<>Nuestros <span tw="text-primary-500" id="feature">Servicios</span></>}
        cards={serviceCards}
      />

      <TwoColumnWithImage
        imageSrc={biometrics}
        heading="Acceso Inteligente para Cualquier Entorno"
        description="Nuestro sistema utiliza QR dinámico con tecnología TOTP, reconocimiento facial, huella dactilar, tarjetas digitales y a través del teléfono móvil. En el caso del acceso QR, cambia cada 30 segundos — cualquier captura de pantalla caduca en segundos. Funciona offline: el visitante activa su pase en línea y el dispositivo valida sin conexión frente al totem. Ideal para fraccionamientos, escuelas, gimnasios, Airbnb y cualquier lugar que requiera acceso controlado."
      />

      <TwoColumnWithImageLeft
        imageSrc={DoorSrc}
        heading="Barreras, Torniquetes y Cerraduras Inteligentes"
        description="Integramos cualquier tipo de barrera física: plumas vehiculares, torniquetes peatonales, cerraduras electromagnéticas y puertas automáticas. La apertura se activa de forma autónoma al validar el QR o la biometría — sin intervención humana. Compatible con ZKTeco, CAME, FAAC y relés vía ESP32."
      />

      <TwoColumnWithImage
        imageSrc={CamaraSrc}
        heading="Videovigilancia Inteligente con IA"
        description="Lecturas automáticas del stream RTSP con OpenCV en .NET Core. Aplicamos varianza Laplaciana para detectar imágenes comprimidas y transformada de Fourier para identificar el efecto Moiré cuando alguien presenta una pantalla frente a la cámara. El totem nunca puede ser engañado con una foto o video del QR real."
      />

      <IoTSection className="mb-12">
        <IoTInner>
          <IoTHeading>Conectividad IoT — Todo Tu Hardware, Una Sola Plataforma</IoTHeading>
          <IoTSubtitle>
            Unificamos sensores, cámaras, barreras y dispositivos inteligentes en la nube.
            Un dashboard, todos tus activos, en tiempo real.
          </IoTSubtitle>
          <IoTGrid>
            {iotFeatures.map((f, i) => (
              <IoTCard key={i}>
                <IoTCardIcon>{f.icon}</IoTCardIcon>
                <IoTCardTitle>{f.title}</IoTCardTitle>
                <IoTCardDesc>{f.desc}</IoTCardDesc>
              </IoTCard>
            ))}
          </IoTGrid>
        </IoTInner>
      </IoTSection>
      
      <VenueSection>
        <ContentWithPaddingXl>
          <VenueHeading>Una Solución, Múltiples Entornos</VenueHeading>
          <VenueSubtitle>
            Nuestro sistema se adapta a cualquier instalación. Si necesitas controlar quién entra, tenemos la solución.
          </VenueSubtitle>
          <VenueGrid>
            {venues.map((v, i) => (
              <VenueCard key={i}>
                <VenueEmoji>{v.emoji}</VenueEmoji>
                <VenueTitle>{v.title}</VenueTitle>
                <VenueDesc>{v.desc}</VenueDesc>
              </VenueCard>
            ))}
          </VenueGrid>
        </ContentWithPaddingXl>
      </VenueSection>

      <SecuritySection>
        <SecurityInner>
          <SecurityHeading>Sistema Anti-Fraude de 4 Capas</SecurityHeading>
          <SecuritySubtitle>
            Cada capa bloquea de forma independiente una clase diferente de ataque.
            Un QR falso tendría que superar las cuatro simultáneamente — algo computacionalmente imposible.
          </SecuritySubtitle>
          <LayersGrid>
            {securityLayers.map((l, i) => (
              <LayerCard key={i}>
                <LayerNumber>{l.number}</LayerNumber>
                <LayerTitle>{l.title}</LayerTitle>
                <LayerDesc>{l.desc}</LayerDesc>
              </LayerCard>
            ))}
          </LayersGrid>
        </SecurityInner>
      </SecuritySection>

      <ProductsSection>
        <ProductsInner>
          <ProductsHeading>Nuestros Productos</ProductsHeading>
          <ProductsSubtitle>
            Además del desarrollo a la medida, contamos con productos propios ya en operación con clientes reales.
            En varios de ellos también vendemos, instalamos y ponemos en marcha el hardware necesario.
          </ProductsSubtitle>
          <ProductsGrid>
            {products.map((p, i) => (
              <ProductCard key={i}>
                {p.imageSrc && <ProductImage imageSrc={p.imageSrc} />}
                <ProductBody>
                  <ProductIconRow>
                    <ProductIconWrapper>
                      <p.Icon />
                    </ProductIconWrapper>
                    <ProductTitle>{p.title}</ProductTitle>
                  </ProductIconRow>
                  {p.hardware && <HardwareBadge>Incluye hardware e instalación</HardwareBadge>}
                  <ProductDesc>{p.description}</ProductDesc>
                  <ProductFeatures>
                    {p.features.map((f, fi) => (
                      <ProductFeatureItem key={fi}>
                        <CheckCircleIcon />
                        <span>{f}</span>
                      </ProductFeatureItem>
                    ))}
                  </ProductFeatures>
                  {p.ctaTo && (
                    <ProductCTA to={p.ctaTo}>
                      {p.ctaText}
                      <ArrowRightIcon />
                    </ProductCTA>
                  )}
                </ProductBody>
              </ProductCard>
            ))}
          </ProductsGrid>
        </ProductsInner>
      </ProductsSection>

      <OurProfessionalTeam
        subheading="Nuestro Equipo"
        heading={<>Ingenieros apasionados <span tw="text-primary-500">construyendo el futuro.</span></>}
        description="Equipo multidisciplinario con experiencia en full-stack, computer vision, hardware IoT y diseño UX. Trabajamos con metodologías ágiles y entregamos proyectos con documentación técnica completa, listos para escalar con tu negocio."
        primaryButtonText="Contacta a nuestro equipo"
        primaryButtonUrl="/bizcode-contactus"
        features={[
          { Icon: CodeIcon, title: "Full-Stack development", description: "Frontend moderno con React, Angular, Vue, Flutter y Svelte. Backend robusto con .NET Core, Java, Python, Node, APIs REST y SignalR para tiempo real." },
          { Icon: ServerIcon, title: "Cloud e Infraestructura", description: "Despliegue en Azure, AWS y GCP. CI/CD automatizado, monitoreo y copias de seguridad diarias incluidas." }
        ]}
      />

      <Portfolio
        subheading="Nuestro Portafolio"
        headingHtmlComponent={<>Proyectos que han <span tw="text-primary-500">transformado comunidades.</span></>}
        description="Cada implementación es una solución a la medida. Contáctanos para conocer más sobre nuestros casos de éxito."
        linkText="Ver todos los proyectos"
        cardLinkText="Solicitar información"
      />

      <Testimonial
        subheading="Lo que dicen nuestros clientes"
        heading={<>Comunidades que <span tw="text-primary-500">confían en nosotros.</span></>}
        description="La seguridad y la experiencia de los residentes son nuestra prioridad."
        testimonials={[
          {
            imageSrc: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1024&q=80",
            profileImageSrc: personIlustration,
            quote: "Desde que instalamos Conexa Home, los residentes ya no tienen que llamar a caseta para dejar entrar visitas. El QR funciona perfecto incluso cuando el visitante no tiene señal. El administrador tiene todo en un solo panel — es exactamente lo que necesitábamos.",
            customerName: "Administrador",
            customerTitle: "Fraccionamiento Monte Verde, Guadalajara"
          },
          {
            imageSrc: "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1024&q=80",
            profileImageSrc: girlIlustration,
            quote: "El sistema de reconocimiento facial es increíble. Como residente, simplemente me acerco y la barrera se abre. Para visitas, generamos el QR desde la app y entran sin problemas. Saber quién entra y cuándo no tiene precio.",
            customerName: "Residente",
            customerTitle: "Fraccionamiento Sant Martí, Guadalajara"
          }
        ]}
        textOnLeft={true}
      />

      <ContactUsForm id="ContactUs" formAction={sendMessage} />

      <DownloadApp
        text={<>Próximamente espera por nuestra versión <HighlightedTextInverse>Móvil.</HighlightedTextInverse></>}
      />

      <Footer />
    </AnimationRevealPage>
  );
};